module.exports = __webpack_public_path__ + "media/bg-long.54bd815b.mp4";